import { createFileRoute, redirect } from '@tanstack/react-router';
import { getStrictCurrentEnterpriseId, isCurrentSessionLoggedIn } from '@mews-commander/core';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/')({
    component: () => null,
    beforeLoad: () => {
        if (isCurrentSessionLoggedIn()) {
            throw redirect({
                to: '/$currentEnterpriseId/Dashboard/Index',
                params: {
                    currentEnterpriseId: getStrictCurrentEnterpriseId(),
                },
                replace: true,
            });
        } else {
            throw redirect({
                to: '/Home/SignIn',
                replace: true,
            });
        }
    },
    staticData: {
        owner: MewsTeam.Productivity,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
